<template>
  <div class="report-fee-summary-container animated fadeInRight">
    <el-row class="flex justify-start" :gutter="20">
      <el-col :span="3" class="padding-r-0">
        <select-community-floor ref="selectCommunityFloor" />
      </el-col>
      <el-col :span="21">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>{{ $t('reportFeeSummary.queryCondition') }}</span>
          </div>
          <div class="text item">
            <el-row :gutter="20">
              <el-col :span="4">
                <el-date-picker v-model="reportFeeSummaryInfo.conditions.startDate" type="date"
                  :placeholder="$t('reportFeeSummary.selectStartDate')" style="width: 100%"
                  @change="handleDateChange" />
              </el-col>
              <el-col :span="4">
                <el-date-picker v-model="reportFeeSummaryInfo.conditions.endDate" type="date"
                  :placeholder="$t('reportFeeSummary.selectEndDate')" style="width: 100%" @change="handleDateChange" />
              </el-col>
              <el-col :span="4">
                <el-input v-model.trim="reportFeeSummaryInfo.conditions.objName"
                  :placeholder="$t('reportFeeSummary.inputRoomNumber')" clearable />
              </el-col>
              <el-col :span="4">
                <el-input v-model.trim="reportFeeSummaryInfo.conditions.ownerName"
                  :placeholder="$t('reportFeeSummary.inputOwnerName')" clearable />
              </el-col>
              <el-col :span="4">
                <el-input v-model.trim="reportFeeSummaryInfo.conditions.link"
                  :placeholder="$t('reportFeeSummary.inputOwnerPhone')" clearable />
              </el-col>
              <el-col :span="4">
                <el-button type="primary" @click="_queryMethod">
                  <i class="el-icon-search"></i>
                  {{ $t('common.search') }}
                </el-button>
                <el-button @click="_resetMethod">
                  <i class="el-icon-refresh"></i>
                  {{ $t('common.reset') }}
                </el-button>
              </el-col>
            </el-row>

            <el-row :gutter="20" class="margin-top">
              <el-col :span="4">
                <el-select v-model="reportFeeSummaryInfo.conditions.feeTypeCd"
                  :placeholder="$t('reportFeeSummary.selectFeeType')" style="width: 100%" clearable>
                  <el-option v-for="(item, index) in reportFeeSummaryInfo.feeTypeCds" :key="index" :label="item.name"
                    :value="item.statusCd" />
                </el-select>
              </el-col>
              <el-col v-if="reportFeeSummaryInfo.communitys.length > 1" :span="4">
                <el-select v-model="reportFeeSummaryInfo.conditions.communityIds"
                  :placeholder="$t('reportFeeSummary.selectCommunity')" style="width: 100%" multiple collapse-tags
                  @change="_changCommunity">
                  <el-option label="所有小区" value="" />
                  <el-option v-for="(item, index) in reportFeeSummaryInfo.communitys" :key="index" :label="item.name"
                    :value="item.communityId" />
                </el-select>
              </el-col>
            </el-row>

            <el-row v-show="reportFeeSummaryInfo.moreCondition" class="margin-top">
              <el-col :span="24">
                <el-checkbox-group v-model="reportFeeSummaryInfo.configIds">
                  <el-checkbox v-for="(item, index) in reportFeeSummaryInfo.feeConfigs" :key="index"
                    :label="item.configId">
                    {{ item.feeName }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-col>
            </el-row>
          </div>
        </el-card>

        <el-card class="box-card margin-top">
          <div slot="header" class="flex justify-between">
            <div>
              <span>{{ $t('reportFeeSummary.feeSummaryTable') }}</span>
              <span class="el-icon-info popover-show" style="cursor: pointer;"></span>
              <span>({{ $t('reportFeeSummary.updateDaily') }})</span>
            </div>
            <div style="float: right;">
              <el-button type="primary" size="small" @click="_exportExcel">
                <i class="el-icon-download"></i>
                {{ $t('common.export') }}
              </el-button>
            </div>
          </div>
          <div class="text item">
            <el-table :data="reportFeeSummaryInfo.fees" border style="width: 100%">
              <el-table-column prop="roomCount" :label="$t('reportFeeSummary.totalRooms')" align="center" />
              <el-table-column prop="feeRoomCount" :label="$t('reportFeeSummary.chargeRooms')" align="center" />
              <el-table-column prop="oweRoomCount" :label="$t('reportFeeSummary.arrearsRooms')" align="center" />
              <el-table-column :label="$t('reportFeeSummary.arrearsFormula')" align="center" colspan="3">
                <el-table-column prop="hisOweFee" :label="$t('reportFeeSummary.historyArrears')" align="center" />
                <el-table-column prop="curOweFee" :label="$t('reportFeeSummary.currentArrears')" align="center" />
                <el-table-column :label="$t('reportFeeSummary.totalArrears')" align="center">
                  <template slot-scope="scope">
                    {{ (scope.row.curOweFee + scope.row.hisOweFee).toFixed(2) }}
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column :label="$t('reportFeeSummary.actualPaymentFormula')" align="center" colspan="4">
                <el-table-column prop="hisReceivedFee" :label="$t('reportFeeSummary.arrearsRecovery')" align="center" />
                <el-table-column :label="$t('reportFeeSummary.currentPartial')" align="center">
                  <template slot-scope="scope">
                    {{ (scope.row.receivedFee - scope.row.hisReceivedFee - scope.row.preReceivedFee).toFixed(2) }}
                  </template>
                </el-table-column>
                <el-table-column prop="preReceivedFee" :label="$t('reportFeeSummary.advancePayment')" align="center" />
                <el-table-column prop="receivedFee" :label="$t('reportFeeSummary.actualPayment')" align="center" />
              </el-table-column>
              <el-table-column prop="curReceivableFee" :label="$t('reportFeeSummary.currentReceivable')"
                align="center" />
              <el-table-column :label="$t('reportFeeSummary.currentActual')" align="center">
                <template slot-scope="scope">
                  {{ (scope.row.curReceivableFee - scope.row.curOweFee).toFixed(2) }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('reportFeeSummary.roomChargeRate')" align="center">
                <template slot-scope="scope">
                  {{ scope.row.feeRoomCount > 0 ? (((scope.row.feeRoomCount - scope.row.oweRoomCount) /
                    scope.row.feeRoomCount * 100).toFixed(2) + '%') : '0%' }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('reportFeeSummary.chargeRate')" align="center">
                <template slot-scope="scope">
                  {{ scope.row.curReceivableFee > 0 ? (((scope.row.curReceivableFee - scope.row.curOweFee) /
                    scope.row.curReceivableFee * 100).toFixed(2) + '%') : '0%' }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('reportFeeSummary.clearanceRate')" align="center">
                <template slot-scope="scope">
                  {{ (scope.row.hisReceivedFee + scope.row.hisOweFee) > 0 ? ((scope.row.hisReceivedFee /
                    (scope.row.hisReceivedFee + scope.row.hisOweFee) * 100).toFixed(2) + '%') : '0%' }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-card>

        <el-card class="box-card margin-top">
          <el-collapse v-model="explainActive">
            <el-collapse-item name="explain">
              <template slot="title">
                <i class="el-icon-info explain-icon"></i>
                <span>{{ $t('reportFeeSummary.indicatorExplanation') }}</span>
              </template>
              <el-table :data="explainIndicators" border size="mini">
                <el-table-column prop="name" :label="explainText.colIndicator" width="150" />
                <el-table-column prop="desc" :label="explainText.colDefinition" />
              </el-table>
              <div class="explain-block">
                <div class="explain-block-title">{{ explainText.formulaTitle }}</div>
                <ul class="explain-list">
                  <li v-for="(item, index) in explainFormulas" :key="index">{{ item }}</li>
                </ul>
              </div>
              <div class="explain-block">
                <div class="explain-block-title">{{ explainText.noteTitle }}</div>
                <ul class="explain-list">
                  <li v-for="(item, index) in explainNotes" :key="index">{{ item }}</li>
                </ul>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-card>

        <div class="margin-top">
          <floor-fee-summary ref="floorFeeSummary" />
        </div>
        <div class="margin-top">
          <config-fee-summary ref="configFeeSummary" />
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getDict, getCommunityId } from '@/api/community/communityApi'
import { queryReportFeeSummary, exportData, queryCommunitys, queryFeeConfigs } from '@/api/report/reportFeeSummaryApi'
import SelectCommunityFloor from '@/components/report/selectCommunityFloor'
import FloorFeeSummary from '@/components/report/floorFeeSummary'
import ConfigFeeSummary from '@/components/report/configFeeSummary'

export default {
  name: 'ReportFeeSummaryList',
  components: {
    SelectCommunityFloor,
    FloorFeeSummary,
    ConfigFeeSummary
  },
  data() {
    return {
      reportFeeSummaryInfo: {
        fees: [],
        feeConfigs: [],
        floors: [],
        configIds: [],
        feeTypeCds: [],
        communitys: [],
        moreCondition: false,
        conditions: {
          floorId: '',
          objName: '',
          startDate: '',
          endDate: '',
          configId: '',
          feeTypeCd: '',
          ownerName: '',
          link: '',
          communityId: '',
          communityIds: []
        }
      },
      explainActive: ['explain']
    }
  },
  created() {
    this.initData()
  },
  computed: {
    isZh() {
      return this.$i18n && this.$i18n.locale ? this.$i18n.locale.indexOf('zh') === 0 : true
    },
    explainText() {
      if (this.isZh) {
        return {
          colIndicator: '指标',
          colDefinition: '定义',
          formulaTitle: '换算关系',
          noteTitle: '注意事项'
        }
      }
      return {
        colIndicator: 'Indicator',
        colDefinition: 'Definition',
        formulaTitle: 'Formulas',
        noteTitle: 'Notes'
      }
    },
    explainIndicators() {
      const t = this.$t.bind(this)
      if (this.isZh) {
        return [
          { name: t('reportFeeSummary.historyArrears'), desc: '查询开始日期之前各月份尚未缴纳的账单总额（期初旧账余额）' },
          { name: t('reportFeeSummary.currentArrears'), desc: '查询区间内账单尚未收取的部分' },
          { name: t('reportFeeSummary.totalArrears'), desc: '历史欠费 + 当期欠费，即截至查询结束日期的全部未收账单' },
          { name: t('reportFeeSummary.arrearsRecovery'), desc: '查询区间内实收金额中，冲抵开始日期之前旧账的部分（即补缴旧账金额）' },
          { name: t('reportFeeSummary.advancePayment'), desc: '查询区间内实收金额中，冲抵结束日期之后账单的部分（即提前缴纳金额）' },
          { name: t('reportFeeSummary.currentPartial'), desc: '实缴 − 欠费追回 − 预交，即实收中冲抵当期账单的部分' },
          { name: t('reportFeeSummary.actualPayment'), desc: '查询区间内实际收到的全部金额，按缴费时间统计，不区分冲抵哪期账单' },
          { name: t('reportFeeSummary.currentReceivable'), desc: '查询区间内账单全额（无论是否已收）' },
          { name: t('reportFeeSummary.currentActual'), desc: '当期应收 − 当期欠费，即当期账单中已收到的部分' },
          { name: t('reportFeeSummary.roomChargeRate'), desc: '(收费户 − 欠费户) ÷ 收费户，已缴清户数占应缴费户数比例' },
          { name: t('reportFeeSummary.chargeRate'), desc: '(当期应收 − 当期欠费) ÷ 当期应收，当期账单收回比例' },
          { name: t('reportFeeSummary.clearanceRate'), desc: '欠费追回 ÷ (欠费追回 + 历史欠费)，历史旧账回收比例' }
        ]
      }
      return [
        { name: t('reportFeeSummary.historyArrears'), desc: 'Unpaid bills for all months before the query start date (opening arrears balance)' },
        { name: t('reportFeeSummary.currentArrears'), desc: 'Unpaid portion of bills within the query period' },
        { name: t('reportFeeSummary.totalArrears'), desc: 'History arrears + current arrears, all unpaid bills as of the end date' },
        { name: t('reportFeeSummary.arrearsRecovery'), desc: 'Amount received in the period that settles bills dated before the start date (back payments)' },
        { name: t('reportFeeSummary.advancePayment'), desc: 'Amount received in the period that settles bills dated after the end date (paid in advance)' },
        { name: t('reportFeeSummary.currentPartial'), desc: 'Actual payment − arrears recovery − advance, the portion settling current-period bills' },
        { name: t('reportFeeSummary.actualPayment'), desc: 'Total amount actually received within the period, by payment time, regardless of which bill it settles' },
        { name: t('reportFeeSummary.currentReceivable'), desc: 'Full amount of bills within the period, whether received or not' },
        { name: t('reportFeeSummary.currentActual'), desc: 'Current receivable − current arrears, the received portion of current bills' },
        { name: t('reportFeeSummary.roomChargeRate'), desc: '(Charge rooms − arrears rooms) ÷ charge rooms' },
        { name: t('reportFeeSummary.chargeRate'), desc: '(Current receivable − current arrears) ÷ current receivable' },
        { name: t('reportFeeSummary.clearanceRate'), desc: 'Arrears recovery ÷ (arrears recovery + history arrears)' }
      ]
    },
    explainFormulas() {
      if (this.isZh) {
        return [
          '实缴 = 欠费追回 + 预交 + 当期部分（按实收金额的冲抵去向拆分）',
          '当期应收 = 当期欠费 + 当期实收（按当期账单收取状态拆分）',
          '总欠费 = 历史欠费 + 当期欠费'
        ]
      }
      return [
        'Actual payment = arrears recovery + advance + current partial (by settlement destination)',
        'Current receivable = current arrears + current actual (by bill payment status)',
        'Total arrears = history arrears + current arrears'
      ]
    },
    explainNotes() {
      if (this.isZh) {
        return [
          '欠费数据由系统按月离散生成，反映的是查询时刻的欠费状态：本期内追回的旧账，会使下一次查询时"历史欠费"相应减少',
          '示例：小区旧账 10 万（历史欠费 10 万），本期补收旧账 3 万、当期收费 20 万、预收 2 万，则本期报表显示：历史欠费 10 万、欠费追回 3 万、预交 2 万、当期部分 20 万、实缴 25 万；下期查询时历史欠费变为 7 万'
        ]
      }
      return [
        'Arrears data is dispersed monthly by the system and reflects the arrears status at query time: old arrears recovered in this period will reduce the "History Arrears" shown in the next query',
        'Example: with 100k old arrears, this period recovers 30k of old bills, collects 200k current and 20k advance; this report shows history arrears 100k, arrears recovery 30k, advance 20k, current partial 200k, actual payment 250k; the next query will show history arrears as 70k'
      ]
    }
  },
  methods: {
    async initData() {
      this.reportFeeSummaryInfo.conditions.communityId = await getCommunityId()
      this._initDate()
      this._loadStaffCommunitys()
      this._listFeeConfigs()
      this.getFeeTypeDict()
      this.$refs.selectCommunityFloor.open({
        callBack: (floor) => {
          this.reportFeeSummaryInfo.conditions.floorId = floor.floorId
          this._listFees()
        }
      })
      this._listFees()
    },
    _initDate() {
      const now = new Date()
      const year = now.getFullYear()
      const month = now.getMonth() + 1
      const lastDay = new Date(year, month, 0).getDate()

      this.reportFeeSummaryInfo.conditions.startDate = `${year}-${month.toString().padStart(2, '0')}-01`
      this.reportFeeSummaryInfo.conditions.endDate = `${year}-${month.toString().padStart(2, '0')}-${lastDay}`
    },
    handleDateChange() {
      if (this.reportFeeSummaryInfo.conditions.startDate && this.reportFeeSummaryInfo.conditions.endDate) {
        const start = new Date(this.reportFeeSummaryInfo.conditions.startDate)
        const end = new Date(this.reportFeeSummaryInfo.conditions.endDate)

        if (start > end) {
          this.$message.error(this.$t('reportFeeSummary.dateError'))
          this.reportFeeSummaryInfo.conditions.endDate = ''
        }
      }
    },
    async getFeeTypeDict() {
      try {
        this.reportFeeSummaryInfo.feeTypeCds = await getDict('pay_fee_config', 'fee_type_cd')
      } catch (error) {
        console.error('Failed to get fee type dict:', error)
      }
    },
    async _listFees() {
      try {
        const params = {
          page: 1,
          row: 100,
          ...this.reportFeeSummaryInfo.conditions,
        }
        if (this.reportFeeSummaryInfo.configIds.length > 0) {
          params.configIds = this.reportFeeSummaryInfo.configIds.join(',')
        }
        if (this.reportFeeSummaryInfo.conditions.communityIds.length > 0) {
          // 多选小区时传数组，communityId 置空由后端 communityIds 过滤
          params.communityId = ''
        } else {
          // 未多选时按当前小区查询
          params.communityIds = []
        }

        const { data } = await queryReportFeeSummary(params)
        this.reportFeeSummaryInfo.fees = data

        // Notify child components
        this.$refs.floorFeeSummary.notify(params)
        this.$refs.configFeeSummary.notify(params)
      } catch (error) {
        console.error('Failed to query fee summary:', error)
      }
    },
    async _loadStaffCommunitys() {
      try {
        const data = await queryCommunitys()
        this.reportFeeSummaryInfo.communitys = data.communitys
      } catch (error) {
        console.error('Failed to load communities:', error)
      }
    },
    async _listFeeConfigs() {
      try {
        const params = {
          page: 1,
          row: 100,
          communityId: this.reportFeeSummaryInfo.conditions.communityId,
          isDefault: 'F'
        }

        const data = await queryFeeConfigs(params)
        this.reportFeeSummaryInfo.feeConfigs = data.feeConfigs
      } catch (error) {
        console.error('Failed to list fee configs:', error)
      }
    },
    _queryMethod() {
      this._listFees()
    },
    _resetMethod() {
      this.reportFeeSummaryInfo.conditions = {
        ...this.reportFeeSummaryInfo.conditions,
        roomNum: '',
        ownerName: '',
        link: '',
        feeTypeCd: '',
        floorName: '',
        floorId: '',
        unitId: '',
        configId: ''
      }
      this.reportFeeSummaryInfo.configIds = []
      this._listFees()
    },
    async _exportExcel() {
      try {
        const params = {
          ...this.reportFeeSummaryInfo.conditions,
          pagePath: 'reportFeeSummary'
        }

        await exportData(params)
        this.$message.success(this.$t('common.operationSuccess'))
        this.$router.push('/pages/property/downloadTempFile?tab=下载中心')
      } catch (error) {
        console.error('Failed to export:', error)
        this.$message.error(this.$t('reportFeeSummary.exportFailed'))
      }
    },
    _changCommunity() {
      this._listFeeConfigs()
      this._listFees()
    }
  }
}
</script>

<style lang="scss" scoped>
.report-fee-summary-container {
  padding: 20px;

  .margin-top {
    margin-top: 20px;
  }

  .padding-r-0 {
    padding-right: 0;
  }

  .popover-show {
    margin-left: 10px;
    color: #409EFF;
  }

  .explain-icon {
    margin-right: 6px;
    color: #409EFF;
  }

  .explain-block {
    margin-top: 15px;
  }

  .explain-block-title {
    font-weight: bold;
    margin-bottom: 8px;
  }

  .explain-list {
    margin: 0;
    padding-left: 20px;

    li {
      line-height: 1.8;
      color: #606266;
    }
  }

  .el-checkbox {
    margin-right: 15px;
  }
}
</style>